import * as React from "react";
const SvgHomeFilled = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "m15.754.998-.002 1.848-.004 1.847-1.338-1.277-1.87-1.785a23.52 23.52 0 0 0-.54-.508 8.92 8.92 0 0 0-.348.324A5645.182 5645.182 0 0 1 3 9.701C2.918 9.785.383 12.21.314 12.27a66.567 66.567 0 0 0 1.375 1.449c.004 0 .3-.278.655-.617l.646-.618.002 5.258.004 5.26H21.006l.002-5.258.002-5.26.646.618c.356.339.65.617.655.617.008 0 1.385-1.442 1.38-1.446a640.298 640.298 0 0 1-2.755-2.636l-.18-.18V.998h-2.502z", style: {
            clipRule: "evenodd",
            fill: "currentColor",
            fillRule: "evenodd",
        } })));
export default SvgHomeFilled;
